<template>
    <Head title="Create New Model" />
    <BreezeAuthenticatedLayout>
        <template #header>
            <h2 class="font-semibold text-xl leading-tight">
                Create New Model
            </h2>
        </template>
        <BreadCrumbs :items="navItems"></BreadCrumbs>
        <div class="w-full my-6 overflow-hidden py-12 shadow">
            <div class="px-6 pt-4 pb-2">
                <form enctype="multipart/form-data" @submit.prevent="create.post(requestUrl, { preserveScroll: true})" class="w-full">
                    <div class="grid grid-cols-1 sm:grid-cols-2 gap-6">
                        <div class="mb-6 md:mb-4">
                            <admin-app-label>Name</admin-app-label>
                            <input-basic
                                placeholder="Name"
                                v-model="create.name"
                                :error="errors['name']"
                            />
                            <input-error v-if="errors['name']">
                                {{ errors.name }}
                            </input-error>
                        </div>
                        <div class="mb-6 md:mb-4">
                            <admin-app-label>Manufacturer</admin-app-label>
                            <input-select
                                placeholder="Manufacturer"
                                labelKey="Manufacturer"
                                label="name"
                                v-model="create.vehicle_manufacturer_id"
                                :options="manufacturers"
                                :error="errors['vehicle_manufacturer_id']"
                                :reduce="manufacturer => manufacturer.id"
                            ></input-select>
                            <input-error v-if="errors['vehicle_manufacturer_id']">
                                {{ errors.vehicle_manufacturer_id }}
                            </input-error>
                        </div>
                    </div>
                    <div class="mb-6 md:mb-4">
                        <admin-app-label>Image</admin-app-label>
                        <image-upload
                            :key="`Image`"
                            :label="`Image`"
                            v-model="create.image"
                            :error="errors['image']"
                        >
                        </image-upload>
                        <input-error v-if="errors['image']">
                            {{ errors.image }}
                        </input-error>
                    </div>
                    <div class="mb-6 md:mb-4">
                        <admin-app-label>Content</admin-app-label>
                        <input-wysiwyg
                            v-model="create.content"
                            ></input-wysiwyg>
                        <input-error v-if="errors['content']">
                            {{ errors.content }}
                        </input-error>
                    </div>
                    <seo-tags v-model="create.seo_tags" :errors="errors"></seo-tags>
                    <app-button type="submit" class="mt-8">Create</app-button>
                </form>
            </div>
        </div>
    </BreezeAuthenticatedLayout>
</template>
<script>
import { useForm } from '@inertiajs/inertia-vue3';
import BreezeAuthenticatedLayout from '@/Layouts/Admin/Authenticated.vue'
import { Head } from '@inertiajs/inertia-vue3';
import Label from "@/Components/Label";
import InputBasic from "@/Components/Admin/Forms/Inputs/InputBasic";
import AppButton from "@/Components/AppButton";
import InputError from "@/Components/Forms/Inputs/InputError";
import AdminAppLabel from "@/Components/Admin/Forms/AdminAppLabel";
import InputSelect from "@/Components/Admin/Forms/Inputs/InputSelect";
import ImageUpload from "@/Components/Admin/Forms/Inputs/ImageUpload";
import InputWysiwyg from "@/Components/Admin/Forms/Inputs/InputWysiwyg";
import BreadCrumbs from "@/Components/Admin/BreadCrumbs";
import SeoTags from "@/Components/Admin/Forms/SeoTags";
export default {
    components: {
        SeoTags,
        BreadCrumbs,
        InputWysiwyg,
        ImageUpload,
        InputSelect,
        AdminAppLabel,
        AppButton,
        InputBasic,
        Label,
        BreezeAuthenticatedLayout,
        Head,
        InputError
    },
    props: {
      name: String,
      manufacturers: Array,
      manufacturer: [String, Number],
      errors: Object,
      requestUrl: {
          type: String,
          default: '/admin/models'
      }
    },
    data() {
        return {
            navItems: [
                { title: 'Models', path: '/admin/models' },
                { title: 'Create New', path: '/admin/models/create' },
            ],
            create: useForm(
                {
                    name: "",
                    vehicle_manufacturer_id: null,
                    image: null,
                    content: "",
                    seo_tags: null
                }
            )
        }
    }
}
</script>
